module.exports = __webpack_public_path__ + "static/media/connectedAccountLight.ea5ab043.svg";